// extracted by mini-css-extract-plugin
export default {"carouselNav":"CarouselBottomNavigation__carouselNav___MLUcV","circle":"CarouselBottomNavigation__circle___MQnKs","active":"CarouselBottomNavigation__active___SYoH1"};